type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
  isNumeric?: boolean;
};

export const APPOINTMENT_LIST_HEADERS: Header[] = [
  {
    key: "srNo",
    label: "No.",
    sortable: false,
    style: { width: "5%" },
  },
  {
    key: "startTime",
    label: "Date & Time",
    sortable: false,
    style: { width: "15%" },
  },
  {
    key: "appointmentTypeDesc",
    label: "Type",
    sortable: false,
  },
  {
    key: "qmeDoctorFullName",
    label: "QME Doctor",
    sortable: false,
    style: { width: "15%" },
  },
  {
    key: "medicareProviderName",
    label: "Location",
    sortable: false,
    style: { width: "20%" },
  },
  {
    key: "appointmentStatusDesc",
    label: "Status",
    sortable: false,
  },
  {
    key: "medicalExamTypeDesc",
    label: "Medical Exam",
    sortable: false,
  },

  {
    key: "actions",
    label: "Action",
    style: { width: "6%" },
  },
  {
    key: "downloads",
    label: "110/SIBTF Form",

    style: { width: "6%", textAlign: "center" },
  },
];

export const QME_HISTORIAN_HEADERS: Header[] = [
  {
    key: "historianStatusName",
    label: "Status",
    sortable: false,
    style: { width: "20%" },
  },
  {
    key: "historianAssignedUsername",
    label: "Historian",
    sortable: false,
    style: { width: "20%" },
  },
  {
    key: "createdDate",
    label: "When",
    sortable: false,
    style: { width: "20%" },
  },
  {
    key: "historianComments",
    label: "Comments",
    sortable: false,
    style: { width: "20%" },
  },
  {
    key: "elapsedDuration",
    label: "Elapsed Time",
    sortable: false,
    style: { width: "20%" },
  },
];

export const QME_EDITOR_HEADERS: Header[] = [
  {
    key: "editorStatusName",
    label: "Status",
    sortable: false,
    style: { width: "20%" },
  },
  {
    key: "editorAssignedUserName",
    label: "Editor",
    sortable: false,
    style: { width: "20%" },
  },
  {
    key: "createdDate",
    label: "When",
    sortable: false,
    style: { width: "20%" },
  },
  {
    key: "editorComments",
    label: "Comments",
    sortable: false,
    style: { width: "20%" },
  },
  {
    key: "elapsedDuration",
    label: "Elapsed Time",
    sortable: false,
    style: { width: "20%" },
  },
];

export const TRANSC_EDITOR_HEADERS: Header[] = [
  {
    key: "transcriberStatusName",
    label: "Status",
    sortable: false,
    style: { width: "20%" },
  },
  {
    key: "transcriberAssignedUserName",
    label: "Transcriber",
    sortable: false,
    style: { width: "20%" },
  },
  {
    key: "createdDateNew",
    label: "When",
    sortable: false,
    style: { width: "20%" },
  },
  {
    key: "transcriberComments",
    label: "Comments",
    sortable: false,
    style: { width: "20%" },
  },
  {
    key: "elapsedDuration",
    label: "Elapsed Time",
    sortable: false,
    style: { width: "20%" },
  },
];
